import { c as _c } from "react/compiler-runtime";
import { PaperClipIcon } from '@heroicons/react/24/solid';
import { Link } from '@/frontend/design-system/actions/Link';
import { cn } from '@/frontend/utils';
export function AttachmentLink(t0) {
  const $ = _c(7);
  const {
    attachment,
    className
  } = t0;
  const t1 = attachment.url;
  const t2 = attachment.url;
  let t3;
  if ($[0] !== className) {
    t3 = cn("flex w-fit flex-row items-center gap-2 text-contentNavyAlgo", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PaperClipIcon className="h-4 w-4" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== attachment.name || $[4] !== attachment.url || $[5] !== t3) {
    t5 = <Link key={t1} href={t2} target="_blank" rel="noopener noreferrer" className={t3}>{t4}{attachment.name}</Link>;
    $[3] = attachment.name;
    $[4] = attachment.url;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}